import OzonSection from './ozon/OzonSection';
import WbSection from './wb/WbSection';

function MarketplaceSection({ activeMarketplace, ozonProps, wbProps, moduleFlags = {} }) {
    return (
        <div className="panel">
            {activeMarketplace === 'ozon' ? (
                <OzonSection {...ozonProps} moduleFlags={moduleFlags} />
            ) : activeMarketplace === 'wildberries' ? (
                <WbSection {...wbProps} />
            ) : (
                <div className="empty">Выберите маркетплейс</div>
            )}
        </div>
    );
}

export default MarketplaceSection;
